import { render, staticRenderFns } from "./SlotProductList_comp.vue?vue&type=template&id=4bc75e88&scoped=true&"
import script from "./SlotProductList_comp.vue?vue&type=script&lang=js&"
export * from "./SlotProductList_comp.vue?vue&type=script&lang=js&"
import style0 from "./SlotProductList_comp.vue?vue&type=style&index=0&id=4bc75e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc75e88",
  null
  
)

export default component.exports